<template>
    <div class="form--box box-span-2">
        <label class="form-label form-label-radio" :class="{'form-label-error' : error}" :for="`${type}-${item.id}`">
            <div class="form-label--grid">
                <div class="form-label--grid--box">
                    <input type="radio" :name="type" class="checkbox checkbox-radio" :id="`${type}-${item.id}`" :checked="selected === item.id" @click="$emit('update', item.id)">
                </div>

                <div class="form-label--grid--box">
                    <p class="font-medium">{{ item.title }}</p>
                </div>

                <div class="form-label--grid--box">
                    <p class="font-medium highlighted">
                        {{ formattedPrice }}
                    </p>
                </div>
            </div>

            <div v-if="deliveryPlaceRequired" class="form-label--body">
                <div class="form-label--body--box">
                    Miesto vyzdvihnutia:

                    <div v-if="selectedParcelService" class="formatted">
                        {{ selectedParcelService.title }}, <br>
                        {{ selectedParcelService.address }}
                    </div>
                </div>

                <div class="form-label--body--box">
                    <span class="btn" :class="selectedParcelService ? 'btn-text-action-blue' : 'btn-padding-medium btn-action-blue'" @click="showPopup = true">
                        {{ selectedParcelService ? 'Zmeniť' : 'Zvoliť miesto vyzdvihnutia' }}
                    </span>
                </div>

                <div v-if="subErrorMessage" class="form--box--error">
                    {{ subErrorMessage }}
                </div>

                <component v-if="showPopup" :is="item.slug" @close="showPopup = false" @update="selectPickupPoint( $event )" />
            </div>
        </label>
    </div>
</template>

<script>
    import packeta from '../../popups/PacketaDeliveryPlacesPopup'
    import glsParcelShopABalikomat from '../../popups/GlsDeliveryPlacesPopup'

    export default {
        components: {
            packeta,
            glsParcelShopABalikomat
        },
        emits: ['update', 'updateParcelService'],
        props: {
            onUpdate: {
                type: Function
            },
            onUpdateParcelService: {
                type: Function
            },
            item: {
                type: Object
            },
            type: {
                type: String
            },
            selected: {
                type: Number
            },
            selectedParcelService: {
                type: Object
            },
            error: {
                type: Boolean
            },
            subError: {
                type: Boolean
            },
            subErrorMessage: {
                type: String
            }
        },
        data() {
            return {
                showPopup: false
            }
        },
        computed: {
            formattedPrice() {
                let price = this.type === 'payment' ? this.item.price_with_tax_formatted : this.item.ranges[0].rules[0].price_with_tax_formatted

                return price
            },
            deliveryPlaceRequired() {
                let value = false

                if ( ['packeta', 'gls-parcel-shop-a-balikomat'].includes( this.item.slug ) ) value = true

                return value
            }
        },
        methods: {
            selectPickupPoint( point ) {
                let data = null

                switch ( this.item.slug ) {

                    case 'packeta':

                        data = {
                            internal_id: point.id,
                            title: point.name,
                            place: point.place,
                            city: point.city,
                            street: point.street,
                            psc: point.zip,
                            currency: point.currency,
                            country: point.country
                        }
                        
                        break

                    case 'gls-parcel-shop-a-balikomat':

                        data = {
                            internal_id: point.id,
                            title: point.name,
                            address: point.contact.address,
                            city: point.contact.city,
                            psc: point.contact.postalCode,
                            country_code: point.contact.countryCode
                        }
                        
                        break
                
                    default:

                        break
                }

                this.$emit('updateParcelService', data)

                this.showPopup = false
            }
        },
    }
</script>